import type { ReactElement, SVGProps } from "react";

/** A blank page with a folded top-right corner — the background layer
 *  `DocPreviewFrame` hosts live content on top of. */
export function PaperPageIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 80 100" preserveAspectRatio="none" aria-hidden {...props}>
      <path
        d="M8 4 h48 l20 20 v68 a4 4 0 0 1 -4 4 h-64 a4 4 0 0 1 -4 -4 v-84 a4 4 0 0 1 4 -4z"
        fill="white"
        stroke="#D8D8DB"
        strokeWidth="1"
      />
      <path d="M56 4 l20 20 h-16 a4 4 0 0 1 -4 -4 z" fill="#EEF0F3" />
    </svg>
  );
}
